var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarredBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 375,
    viewBox: "0 0 390 375",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.79 101.517C126.79 101.957 126.409 102.314 125.938 102.314C125.467 102.314 125.086 101.956 125.086 101.517C125.086 101.076 125.467 100.719 125.938 100.719C126.408 100.719 126.79 101.076 126.79 101.517Z",
    fill: "url(#paint0_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M348.581 228.669C348.581 229.109 348.2 229.466 347.729 229.466C347.259 229.466 346.877 229.109 346.877 228.669C346.877 228.228 347.259 227.871 347.729 227.871C348.2 227.871 348.581 228.228 348.581 228.669Z",
    fill: "url(#paint1_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.04423 249.717C4.04423 250.158 3.66305 250.514 3.19223 250.514C2.72142 250.514 2.34024 250.157 2.34024 249.717C2.34024 249.276 2.72142 248.919 3.19223 248.919C3.66305 248.919 4.04423 249.276 4.04423 249.717Z",
    fill: "url(#paint2_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M371.691 303.679C371.691 304.119 371.31 304.476 370.839 304.476C370.368 304.476 369.987 304.119 369.987 303.679C369.987 303.239 370.368 302.881 370.839 302.881C371.31 302.881 371.691 303.238 371.691 303.679Z",
    fill: "url(#paint3_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M344.826 318.403C344.826 318.844 344.445 319.201 343.974 319.201C343.503 319.201 343.122 318.843 343.122 318.403C343.122 317.963 343.503 317.606 343.974 317.606C344.445 317.606 344.826 317.963 344.826 318.403Z",
    fill: "url(#paint4_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M371.292 373.254C371.292 373.695 370.911 374.052 370.44 374.052C369.97 374.052 369.588 373.694 369.588 373.254C369.588 372.815 369.97 372.457 370.44 372.457C370.911 372.457 371.292 372.814 371.292 373.254Z",
    fill: "url(#paint5_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9614 343.318C69.9614 343.759 69.5802 344.116 69.1094 344.116C68.6386 344.116 68.2574 343.758 68.2574 343.318C68.2574 342.878 68.6386 342.521 69.1094 342.521C69.5793 342.521 69.9614 342.878 69.9614 343.318Z",
    fill: "url(#paint6_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.009 356.445C100.009 356.886 99.6282 357.243 99.1574 357.243C98.6866 357.243 98.3054 356.885 98.3054 356.445C98.3054 356.005 98.6866 355.648 99.1574 355.648C99.6274 355.648 100.009 356.005 100.009 356.445Z",
    fill: "url(#paint7_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M134.041 325.363C134.041 325.804 133.66 326.16 133.189 326.16C132.718 326.16 132.337 325.804 132.337 325.363C132.337 324.922 132.718 324.565 133.189 324.565C133.66 324.565 134.041 324.923 134.041 325.363Z",
    fill: "url(#paint8_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23832 128.528C7.23832 128.968 6.85714 129.325 6.38633 129.325C5.91551 129.325 5.53433 128.968 5.53433 128.528C5.53433 128.087 5.91638 127.73 6.38633 127.73C6.85714 127.73 7.23832 128.087 7.23832 128.528Z",
    fill: "url(#paint9_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M289.337 114.192C289.337 114.633 288.955 114.99 288.485 114.99C288.015 114.99 287.633 114.633 287.633 114.192C287.633 113.752 288.015 113.395 288.485 113.395C288.956 113.395 289.337 113.753 289.337 114.192Z",
    fill: "url(#paint10_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M384.842 133.761C384.842 134.202 384.461 134.559 383.99 134.559C383.519 134.559 383.138 134.201 383.138 133.761C383.138 133.32 383.519 132.964 383.99 132.964C384.461 132.964 384.842 133.32 384.842 133.761Z",
    fill: "url(#paint11_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M175.271 56.3227C175.271 56.7634 174.889 57.1201 174.419 57.1201C173.949 57.1201 173.567 56.7634 173.567 56.3227C173.567 55.882 173.949 55.5253 174.419 55.5253C174.889 55.5253 175.271 55.882 175.271 56.3227Z",
    fill: "url(#paint12_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.285 79.9553C34.285 80.3959 33.903 80.7527 33.4331 80.7527C32.9622 80.7527 32.5811 80.3959 32.5811 79.9553C32.5811 79.5146 32.9622 79.1578 33.4331 79.1578C33.903 79.1578 34.285 79.5146 34.285 79.9553Z",
    fill: "url(#paint13_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6918 96.3445C53.6918 96.7852 53.3097 97.142 52.8398 97.142C52.369 97.142 51.9878 96.7852 51.9878 96.3445C51.9878 95.9039 52.369 95.5471 52.8398 95.5471C53.3097 95.5471 53.6918 95.9039 53.6918 96.3445Z",
    fill: "url(#paint14_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9514 122.885C31.9514 123.326 31.5694 123.683 31.0994 123.683C30.6286 123.683 30.2474 123.326 30.2474 122.885C30.2474 122.445 30.6286 122.088 31.0994 122.088C31.5694 122.088 31.9514 122.445 31.9514 122.885Z",
    fill: "url(#paint15_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M134.893 21.1453C134.893 21.586 134.512 21.9427 134.041 21.9427C133.57 21.9427 133.189 21.586 133.189 21.1453C133.189 20.7047 133.57 20.3479 134.041 20.3479C134.512 20.3479 134.893 20.7047 134.893 21.1453Z",
    fill: "url(#paint16_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M109.462 48.571C109.462 49.0116 109.08 49.3684 108.61 49.3684C108.139 49.3684 107.758 49.0116 107.758 48.571C107.758 48.1303 108.139 47.7736 108.61 47.7736C109.08 47.7736 109.462 48.1303 109.462 48.571Z",
    fill: "url(#paint17_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M106.626 0.797421C106.626 1.23808 106.244 1.59484 105.774 1.59484C105.303 1.59484 104.922 1.23808 104.922 0.797421C104.922 0.356761 105.303 0 105.774 0C106.244 0 106.626 0.356761 106.626 0.797421Z",
    fill: "url(#paint18_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M264.912 71.5744C264.912 72.0151 264.531 72.3718 264.06 72.3718C263.589 72.3718 263.208 72.0151 263.208 71.5744C263.208 71.1337 263.59 70.777 264.06 70.777C264.531 70.777 264.912 71.1337 264.912 71.5744Z",
    fill: "url(#paint19_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M308.532 27.1207C308.532 27.5613 308.151 27.9181 307.68 27.9181C307.209 27.9181 306.828 27.5613 306.828 27.1207C306.828 26.68 307.209 26.3232 307.68 26.3232C308.151 26.3232 308.532 26.68 308.532 27.1207Z",
    fill: "url(#paint20_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M325.922 3.45147C325.922 3.89213 325.541 4.2489 325.07 4.2489C324.599 4.2489 324.218 3.89213 324.218 3.45147C324.218 3.01082 324.599 2.65405 325.07 2.65405C325.541 2.65405 325.922 3.01082 325.922 3.45147Z",
    fill: "url(#paint21_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M365.621 2.56683C365.621 3.00749 365.24 3.36425 364.769 3.36425C364.298 3.36425 363.917 3.00749 363.917 2.56683C363.917 2.12617 364.298 1.76941 364.769 1.76941C365.24 1.76941 365.621 2.12617 365.621 2.56683Z",
    fill: "url(#paint22_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M255.974 7.87494C255.974 8.3156 255.593 8.67236 255.122 8.67236C254.651 8.67236 254.27 8.3156 254.27 7.87494C254.27 7.43428 254.651 7.07751 255.122 7.07751C255.593 7.07751 255.974 7.43428 255.974 7.87494Z",
    fill: "url(#paint23_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M376.316 27.1205C376.316 27.5612 375.935 27.918 375.464 27.918C374.993 27.918 374.612 27.5612 374.612 27.1205C374.612 26.6799 374.994 26.3231 375.464 26.3231C375.934 26.3231 376.316 26.6799 376.316 27.1205Z",
    fill: "url(#paint24_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M354.278 72.4578C354.278 72.8985 353.897 73.2552 353.426 73.2552C352.955 73.2552 352.574 72.8985 352.574 72.4578C352.574 72.0172 352.956 71.6604 353.426 71.6604C353.896 71.6604 354.278 72.0172 354.278 72.4578Z",
    fill: "url(#paint25_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M384.842 84.2156C384.842 84.6563 384.461 85.0131 383.99 85.0131C383.519 85.0131 383.138 84.6563 383.138 84.2156C383.138 83.775 383.519 83.4182 383.99 83.4182C384.461 83.4182 384.842 83.7758 384.842 84.2156Z",
    fill: "url(#paint26_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M204.486 106.418C204.486 106.858 204.104 107.215 203.634 107.215C203.164 107.215 202.782 106.858 202.782 106.418C202.782 105.977 203.164 105.62 203.634 105.62C204.105 105.62 204.486 105.978 204.486 106.418Z",
    fill: "url(#paint27_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M390 190.789C390 191.23 389.619 191.587 389.148 191.587C388.677 191.587 388.296 191.23 388.296 190.789C388.296 190.349 388.677 189.992 389.148 189.992C389.619 189.992 390 190.349 390 190.789Z",
    fill: "url(#paint28_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M107.474 172.058C107.474 172.499 107.092 172.855 106.622 172.855C106.151 172.855 105.77 172.499 105.77 172.058C105.77 171.617 106.151 171.26 106.622 171.26C107.092 171.26 107.474 171.618 107.474 172.058Z",
    fill: "url(#paint29_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M383.138 249.717C383.138 250.158 382.756 250.514 382.286 250.514C381.815 250.514 381.434 250.158 381.434 249.717C381.434 249.276 381.815 248.919 382.286 248.919C382.757 248.919 383.138 249.276 383.138 249.717Z",
    fill: "url(#paint30_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8424 274.169C33.8424 274.609 33.4612 274.966 32.9904 274.966C32.5196 274.966 32.1384 274.609 32.1384 274.169C32.1384 273.728 32.5196 273.371 32.9904 273.371C33.4612 273.371 33.8424 273.728 33.8424 274.169Z",
    fill: "url(#paint31_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5278 294.517C56.5278 294.957 56.1466 295.314 55.6758 295.314C55.205 295.314 54.8238 294.957 54.8238 294.517C54.8238 294.076 55.205 293.719 55.6758 293.719C56.1466 293.719 56.5278 294.076 56.5278 294.517Z",
    fill: "url(#paint32_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8424 348.483C33.8424 348.924 33.4612 349.28 32.9904 349.28C32.5196 349.28 32.1384 348.924 32.1384 348.483C32.1384 348.042 32.5196 347.686 32.9904 347.686C33.4612 347.686 33.8424 348.042 33.8424 348.483Z",
    fill: "url(#paint33_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09027 312.454C8.09027 312.895 7.7091 313.251 7.23828 313.251C6.76747 313.251 6.38629 312.895 6.38629 312.454C6.38629 312.013 6.76747 311.656 7.23828 311.656C7.7091 311.656 8.09027 312.013 8.09027 312.454Z",
    fill: "url(#paint34_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9921 163.388C55.9921 163.777 55.611 164.093 55.1401 164.093C54.6693 164.093 54.2881 163.778 54.2881 163.388C54.2881 163 54.6693 162.684 55.1401 162.684C55.611 162.684 55.9921 163 55.9921 163.388Z",
    fill: "url(#paint35_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M221.158 343.318C221.628 343.318 222.01 342.961 222.01 342.521C222.01 342.08 221.628 341.723 221.158 341.723C220.687 341.723 220.306 342.08 220.306 342.521C220.306 342.961 220.687 343.318 221.158 343.318Z",
    fill: "url(#paint36_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6779 272.365C99.6779 272.805 99.2967 273.162 98.8259 273.162C98.3551 273.162 97.9739 272.805 97.9739 272.365C97.9739 271.924 98.3551 271.567 98.8259 271.567C99.2967 271.567 99.6779 271.925 99.6779 272.365Z",
    fill: "url(#paint37_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M257.107 36.4577C257.107 36.8984 256.726 37.2551 256.255 37.2551C255.784 37.2551 255.403 36.8984 255.403 36.4577C255.403 36.017 255.784 35.6603 256.255 35.6603C256.726 35.6603 257.107 36.017 257.107 36.4577Z",
    fill: "url(#paint38_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6205 29.6852C27.6205 30.1259 27.2393 30.4827 26.7685 30.4827C26.2977 30.4827 25.9165 30.1259 25.9165 29.6852C25.9165 29.2446 26.2977 28.8878 26.7685 28.8878C27.2393 28.887 27.6205 29.2446 27.6205 29.6852Z",
    fill: "url(#paint39_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6735 54.4365C85.0227 54.7167 84.7798 54.9431 84.4813 57.425C84.182 54.9439 83.94 54.7167 81.2883 54.4365C83.9392 54.1563 84.182 53.9299 84.4813 51.448C84.7798 53.9299 85.0218 54.1571 87.6735 54.4365Z",
    fill: "url(#paint40_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0307 7.41196C44.3799 7.69216 44.1371 7.9186 43.8386 10.4005C43.5392 7.91941 43.2973 7.69216 40.6456 7.41196C43.2964 7.13176 43.5392 6.90533 43.8386 4.42346C44.1371 6.90533 44.379 7.13258 47.0307 7.41196Z",
    fill: "url(#paint41_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38516 191.617C3.73433 191.897 3.49152 192.124 3.19302 194.605C2.89364 192.124 2.65171 191.897 0 191.617C2.65171 191.337 2.89364 191.111 3.19302 188.629C3.49152 191.111 3.73345 191.338 6.38516 191.617Z",
    fill: "url(#paint42_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M308.862 347.135C306.211 347.415 305.968 347.642 305.669 350.124C305.37 347.643 305.128 347.415 302.476 347.135C305.127 346.855 305.37 346.629 305.669 344.147C305.968 346.629 306.21 346.856 308.862 347.135Z",
    fill: "url(#paint43_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M355.178 344.481C352.527 344.761 352.285 344.988 351.986 347.47C351.687 344.989 351.445 344.761 348.793 344.481C351.444 344.201 351.687 343.975 351.986 341.493C352.285 343.975 352.527 344.202 355.178 344.481Z",
    fill: "url(#paint44_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M211.945 24.133C209.294 24.4132 209.051 24.6397 208.752 27.1215C208.452 24.6405 208.21 24.4132 205.559 24.133C208.209 23.8528 208.452 23.6264 208.752 21.1445C209.051 23.6264 209.293 23.8536 211.945 24.133Z",
    fill: "url(#paint45_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M140.61 39.2611C137.959 39.5413 137.716 39.7677 137.417 42.2496C137.118 39.7685 136.876 39.5413 134.224 39.2611C136.875 38.9809 137.118 38.7544 137.417 36.2726C137.716 38.7544 137.958 38.9817 140.61 39.2611Z",
    fill: "url(#paint46_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M314.065 65.3025C311.415 65.5818 311.172 65.8091 310.872 68.291C310.573 65.8091 310.331 65.5827 307.679 65.3025C310.33 65.0223 310.573 64.7958 310.872 62.314C311.172 64.7958 311.415 65.0223 314.065 65.3025Z",
    fill: "url(#paint47_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M347.618 35.7223C344.967 36.0016 344.724 36.2289 344.425 38.7108C344.126 36.2289 343.884 36.0025 341.232 35.7223C343.883 35.4421 344.126 35.2156 344.425 32.7338C344.724 35.2156 344.967 35.4421 347.618 35.7223Z",
    fill: "url(#paint48_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M304.988 204.714C302.337 204.993 302.095 205.22 301.795 207.702C301.496 205.22 301.254 204.994 298.602 204.714C301.253 204.434 301.496 204.207 301.795 201.725C302.095 204.207 302.337 204.434 304.988 204.714Z",
    fill: "url(#paint49_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M315.977 255.854C313.326 256.134 313.084 256.361 312.784 258.842C312.485 256.361 312.243 256.134 309.592 255.854C312.243 255.574 312.486 255.347 312.784 252.865C313.084 255.347 313.326 255.574 315.977 255.854Z",
    fill: "url(#paint50_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M206.826 313.696C204.176 313.975 203.933 314.202 203.633 316.683C203.334 314.202 203.092 313.975 200.44 313.696C203.091 313.416 203.334 313.189 203.633 310.707C203.933 313.189 204.175 313.416 206.826 313.696Z",
    fill: "url(#paint51_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M121.372 249.717C118.721 249.997 118.479 250.223 118.179 252.705C117.88 250.224 117.638 249.997 114.986 249.717C117.637 249.436 117.88 249.21 118.179 246.728C118.479 249.21 118.721 249.436 121.372 249.717Z",
    fill: "url(#paint52_linear_4335_8628)",
    fillOpacity: 0.6
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M358.824 106.416C356.172 106.696 355.93 106.923 355.631 109.404C355.332 106.923 355.09 106.696 352.438 106.416C355.089 106.136 355.332 105.91 355.631 103.428C355.93 105.91 356.173 106.137 358.824 106.416Z",
    fill: "url(#paint53_linear_4335_8628)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4335_8628",
    x1: 125.996,
    y1: 100.586,
    x2: 125.848,
    y2: 103.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4335_8628",
    x1: 347.787,
    y1: 227.738,
    x2: 347.639,
    y2: 230.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4335_8628",
    x1: 3.25019,
    y1: 248.786,
    x2: 3.10216,
    y2: 251.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4335_8628",
    x1: 370.897,
    y1: 302.748,
    x2: 370.749,
    y2: 305.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4335_8628",
    x1: 344.032,
    y1: 317.473,
    x2: 343.884,
    y2: 320.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4335_8628",
    x1: 370.498,
    y1: 372.324,
    x2: 370.35,
    y2: 375.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4335_8628",
    x1: 69.1673,
    y1: 342.388,
    x2: 69.0193,
    y2: 345.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4335_8628",
    x1: 99.2154,
    y1: 355.515,
    x2: 99.0673,
    y2: 358.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4335_8628",
    x1: 133.247,
    y1: 324.432,
    x2: 133.099,
    y2: 327.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4335_8628",
    x1: 6.44428,
    y1: 127.597,
    x2: 6.29625,
    y2: 130.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4335_8628",
    x1: 288.543,
    y1: 113.262,
    x2: 288.395,
    y2: 115.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4335_8628",
    x1: 384.048,
    y1: 132.831,
    x2: 383.9,
    y2: 135.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4335_8628",
    x1: 174.477,
    y1: 55.3922,
    x2: 174.329,
    y2: 58.0808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4335_8628",
    x1: 33.491,
    y1: 79.0247,
    x2: 33.343,
    y2: 81.7133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4335_8628",
    x1: 52.8977,
    y1: 95.414,
    x2: 52.7497,
    y2: 98.1026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4335_8628",
    x1: 31.1574,
    y1: 121.955,
    x2: 31.0094,
    y2: 124.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4335_8628",
    x1: 134.099,
    y1: 20.2148,
    x2: 133.951,
    y2: 22.9034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4335_8628",
    x1: 108.668,
    y1: 47.6405,
    x2: 108.519,
    y2: 50.3291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4335_8628",
    x1: 105.831,
    y1: -0.133094,
    x2: 105.683,
    y2: 2.5555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4335_8628",
    x1: 264.118,
    y1: 70.6439,
    x2: 263.97,
    y2: 73.3325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4335_8628",
    x1: 307.738,
    y1: 26.1901,
    x2: 307.59,
    y2: 28.8787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4335_8628",
    x1: 325.128,
    y1: 2.52096,
    x2: 324.98,
    y2: 5.20956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4335_8628",
    x1: 364.827,
    y1: 1.63632,
    x2: 364.679,
    y2: 4.32492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4335_8628",
    x1: 255.18,
    y1: 6.94442,
    x2: 255.032,
    y2: 9.63302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4335_8628",
    x1: 375.522,
    y1: 26.19,
    x2: 375.374,
    y2: 28.8786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4335_8628",
    x1: 353.484,
    y1: 71.5273,
    x2: 353.336,
    y2: 74.2159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4335_8628",
    x1: 384.048,
    y1: 83.2851,
    x2: 383.9,
    y2: 85.9737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4335_8628",
    x1: 203.692,
    y1: 105.487,
    x2: 203.544,
    y2: 108.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4335_8628",
    x1: 389.206,
    y1: 189.859,
    x2: 389.058,
    y2: 192.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4335_8628",
    x1: 106.68,
    y1: 171.127,
    x2: 106.532,
    y2: 173.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4335_8628",
    x1: 382.344,
    y1: 248.786,
    x2: 382.196,
    y2: 251.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4335_8628",
    x1: 33.0484,
    y1: 273.238,
    x2: 32.9003,
    y2: 275.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4335_8628",
    x1: 55.7337,
    y1: 293.586,
    x2: 55.5857,
    y2: 296.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_4335_8628",
    x1: 33.0484,
    y1: 347.552,
    x2: 32.9003,
    y2: 350.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_4335_8628",
    x1: 7.29624,
    y1: 311.523,
    x2: 7.14821,
    y2: 314.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_4335_8628",
    x1: 55.1981,
    y1: 162.566,
    x2: 55.0825,
    y2: 164.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_4335_8628",
    x1: 221.216,
    y1: 341.59,
    x2: 221.068,
    y2: 344.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_4335_8628",
    x1: 98.8839,
    y1: 271.434,
    x2: 98.7358,
    y2: 274.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_4335_8628",
    x1: 256.313,
    y1: 35.5272,
    x2: 256.165,
    y2: 38.2158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_4335_8628",
    x1: 26.8265,
    y1: 28.7547,
    x2: 26.6784,
    y2: 31.4433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_4335_8628",
    x1: 84.6981,
    y1: 50.9492,
    x2: 84.1432,
    y2: 61.0253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_4335_8628",
    x1: 44.0553,
    y1: 3.92467,
    x2: 43.5005,
    y2: 14.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_4335_8628",
    x1: 3.40977,
    y1: 188.13,
    x2: 2.85505,
    y2: 198.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_4335_8628",
    x1: 305.886,
    y1: 343.648,
    x2: 305.331,
    y2: 353.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_4335_8628",
    x1: 352.203,
    y1: 340.994,
    x2: 351.648,
    y2: 351.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_4335_8628",
    x1: 208.969,
    y1: 20.6457,
    x2: 208.414,
    y2: 30.7218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_4335_8628",
    x1: 137.634,
    y1: 35.7738,
    x2: 137.079,
    y2: 45.8499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_4335_8628",
    x1: 311.09,
    y1: 61.8152,
    x2: 310.535,
    y2: 71.8912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_4335_8628",
    x1: 344.642,
    y1: 32.235,
    x2: 344.087,
    y2: 42.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_4335_8628",
    x1: 302.013,
    y1: 201.226,
    x2: 301.458,
    y2: 211.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_4335_8628",
    x1: 313.002,
    y1: 252.367,
    x2: 312.447,
    y2: 262.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_4335_8628",
    x1: 203.851,
    y1: 310.209,
    x2: 203.296,
    y2: 320.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_4335_8628",
    x1: 118.396,
    y1: 246.229,
    x2: 117.842,
    y2: 256.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_4335_8628",
    x1: 355.848,
    y1: 102.929,
    x2: 355.293,
    y2: 113.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarredBackground);
export default __webpack_public_path__ + "static/media/starredBackground.4c5a9c23925fd5b8b0bd72755d2cf81e.svg";
export { ForwardRef as ReactComponent };